import { breadcrumbsState } from './state';

export default (placeholder) => ({
  state: breadcrumbsState(placeholder),
  namespaced: true,
});
